export interface PaginationConfig {
    totalCount: number;
    pageSize: number;
    siblingCount?: number;
    currentPage: number;
}

export const DOTS = '...';
